/**
 * @author vishwadeep.kapoor
 * RestaurantDetails constants
 */

// import { generateTime } from '../../devUtils/commonUtils';
import { constants } from '../../devUtils';
// export const timeAry = generateTime(true, 10, 24);

export const DEFAULT_ACTION = '/RestaurantDetails/DEFAULT_ACTION';
export const FETCH_RESTAURANT_SUCCESS = '/RestaurantDetails/FETCH_RESTAURANT_SUCCESS';
export const FETCH_RESTAURANT_ERROR = '/RestaurantDetails/FETCH_RESTAURANT_ERROR';
export const SET_RESTURANT_DEAL_FORM = '/RestaurantDetails/SET_RESTURANT_DEAL_FORM';
export const SET_RESTURANT_DEAL_SUCCESS = '/RestaurantDetails/SET_RESTURANT_DEAL_SUCCESS';
// export const GUEST_NUMBERS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

/**
 * @todo matching with the current time
 * @moving to further scope as it need to get the package updation
 */
export const PRE_BOOKING_CONDITIONS = ({ bookingdate }, { currentDate }) => {
  if (new Date(bookingdate) >= new Date(currentDate)) {
    return { isValid: true };
  }
  return { isValid: false, msg: constants.ALERT_BOOKING_VALIDATION };
};
export const MANDATORY_FIELDS = ['number', 'mandatory', 'time'];



// WEBPACK FOOTER //
// client/containers/RestaurantDetails/constants.js